<div class="case-study-overview" *ngIf="active">
    <div *ngIf="tabsContent!== null">
        <div class="tab-title"><span>{{tabsTitle}}</span></div>
        <div class="tab-content body-text-heavy" *ngIf="readMeData">
            <cloudlabs-markdown [readMeData]="readMeData"></cloudlabs-markdown>
        </div>
    </div>
</div>